import { render } from "./SplashSceen.vue?vue&type=template&id=707685c2&scoped=true"
import script from "./SplashSceen.vue?vue&type=script&lang=js"
export * from "./SplashSceen.vue?vue&type=script&lang=js"

import "./SplashSceen.vue?vue&type=style&index=0&id=707685c2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707685c2"]])

export default __exports__